import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PlandayIntegrationState {
    loading: boolean
    activated: boolean | null
    activationUnhandled: boolean
    authenticationUrl: string | null
    error: Error | string | null
}

const initialState: PlandayIntegrationState = {
    loading: false,
    activated: null,
    activationUnhandled: false,
    authenticationUrl: null,
    error: null
}

export const plandayIntegrationSlice = createSlice({
    name: 'plandayIntegration',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        activationStatusFetched: (state, action: PayloadAction<boolean>) => {
            state.loading = false
            state.activated = action.payload
            state.error = null
        },
        activationStatusFetchFailue: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        authenticationUrlFetched: (state, action: PayloadAction<string>) => {
            state.loading = false
            state.authenticationUrl = action.payload
            state.error = null
        },
        authenticationUrlFetchFailue: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        integrationActivated: state => {
            state.loading = false
            state.activated = true
            state.activationUnhandled = true
            state.error = null
        },
        integrationActivationFailue: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        activationHandled: state => {
            state.activationUnhandled = false
        },
    }
})

export const { 
    loading, 
    activationStatusFetched, 
    activationStatusFetchFailue,
    authenticationUrlFetched,
    authenticationUrlFetchFailue,
    integrationActivated,
    integrationActivationFailue,
    activationHandled
} = plandayIntegrationSlice.actions

export default plandayIntegrationSlice.reducer